import "./colors-popup";
import "./product-card-gallery";
import "./spoiler";
import "./landing-el-queue";
import "./articles";
import "./forms";

import { initClientIDs } from "./clientIDs";
initClientIDs();
